const isProduction = process.env.NODE_ENV === "production";

export const imgUrl =
  process.env.REACT_APP_MEDIA_URL ||
  (isProduction
    ? "https://media.finlive.net/"
    : "https://media.abbg.co.kr/");

export const apiUrl =
  process.env.REACT_APP_API_URL ||
  (isProduction
    ? "https://admin.finlive.net/api"
    : "http://localhost:8081/api");

export const homeUrl =
  process.env.REACT_APP_HOME_URL || "https://finlive.net";
